<template>
  <div class="mobile-step3">
    <!-- 寄修设备部分 -->
    <van-cell
      title="寄回的故障设备"
      is-link
      @click="showPartsPopup = true"
      :value="getPartsDisplayText"
    />

    <van-popup v-model="showPartsPopup" position="bottom" round>
      <div class="popup-container">
        <div class="popup-header">
          <div class="popup-title">选择寄回的故障设备</div>
          <van-icon name="cross" @click="showPartsPopup = false" />
        </div>
        <div class="popup-content">
          <div v-if="selectType === '1'" class="parts-selection">
            <van-checkbox-group v-model="device.fittings">
              <van-cell
                v-for="item in partsOpts"
                :key="item.id"
                :title="item.name"
                @click="toggleCheckbox(item.id)"
              >
                <template #right-icon>
                  <van-checkbox
                    :name="item.id"
                    ref="checkboxes"
                    shape="square"
                  />
                </template>
              </van-cell>
            </van-checkbox-group>
          </div>
        </div>
        <div class="popup-footer">
          <van-button type="primary" block @click="confirmParts" class="orange"
            >确认</van-button
          >
        </div>
      </div>
    </van-popup>

    <!-- 物流信息部分 -->
    <van-cell
      title="物流信息"
      is-link
      @click="initLogistics"
      :value="getLogisticsDisplayText"
      required
    />

    <van-popup
      v-model="showLogisticsPopup"
      position="bottom"
      round
      style="height: 80%"
    >
      <div class="popup-container">
        <div class="popup-header">
          <div class="popup-title" style="display: flex; align-items: center">
            物流信息
          </div>

          <van-icon name="cross" @click="showLogisticsPopup = false" />
        </div>
        <div
          class="popup-content"
          style="overflow-y: auto; max-height: calc(80vh - 100px)"
        >
          <div class="mt10">
            <van-cell-group>
              <template #title>
                <div>
                  <span
                    style="
                      color: #666;
                      font-weight: bold;
                      margin-right: 10px;
                      font-size: 16px;
                    "
                    >维修完成后回寄地址</span
                  >
                  <span
                    class="field-tip"
                    style="background: transparent; padding: 0"
                    >后续状态请通过收货手机号查询</span
                  >
                </div>
              </template>
              <van-field
                v-model="params.sendContact"
                label="姓名"
                placeholder="请输入姓名"
                required
                :rules="[{ required: true, message: '姓名不能为空' }]"
              />

              <van-field
                v-model="params.sendPhone"
                label="手机"
                placeholder="请输入手机号"
                required
                type="tel"
                :rules="[
                  {
                    required: true,
                    validator: checkphone,
                    message: '请输入正确的手机号码',
                  },
                ]"
              />

              <!-- <van-field v-model="params.email" label="邮箱" placeholder="请输入邮箱" type="email" />

            <van-field v-model="params.zipCode" label="邮政编码" placeholder="请输入邮政编码" /> -->

              <van-field
                v-model="areaText"
                label="所在地区"
                placeholder="请选择所在地区"
                readonly
                required
                is-link
                @click="showAreaPicker = true"
              />

              <van-field
                v-model="params.tmpAddress"
                label="详细地址"
                placeholder="请输入详细地址"
                required
                :rules="[{ required: true, message: '详细地址不能为空' }]"
              />
            </van-cell-group>
          </div>

          <div class="mt10">
            <van-cell-group
              title="寄出快递（如暂无快递信息，可先提交，后续再更新）"
            >
              <template #title>
                <div>
                  <span
                    style="
                      color: #666;
                      font-weight: bold;
                      margin-right: 10px;
                      font-size: 16px;
                    "
                  >
                    寄出快递 </span
                  >（如暂无快递信息，可先提交，后续再更新）
                </div>
              </template>
              <div>
                <van-button
                  type="default"
                  size="mini"
                  @click="showAddressPopup = true"
                  class="popup-title-btn"
                >
                  文石维修地址
                </van-button>
              </div>
              <van-field
                v-model="params.customer"
                label="寄件人姓名"
                placeholder="请输入寄件人姓名"
                v-if="!$route.query.t"
              >
                <template #button>
                  <van-button size="small" type="primary" @click="syncUserInfo"
                    >同步回寄信息</van-button
                  >
                </template>
              </van-field>

              <van-field
                v-model="params.phone"
                label="寄件人手机"
                placeholder="请输入寄件人手机号"
                v-if="!$route.query.t"
              />

              <van-field
                v-model="params.receiveDeliveryInc.text"
                label="快递公司"
                placeholder="请选择快递公司"
                readonly
                is-link
                @click="showExpressPicker = true"
              />

              <van-field
                v-model="params.receiveDeliveryCode"
                label="快递单号"
                placeholder="请输入快递单号"
              />
              <div class="field-tip">
                为确保运送安全，建议使用顺丰，请勿到付！
              </div>
            </van-cell-group>
          </div>
        </div>
        <div class="popup-footer">
          <van-button
            type="primary"
            block
            @click="confirmLogistics"
            class="orange"
            >确认</van-button
          >
        </div>
      </div>
    </van-popup>

    <!-- 寄件需知（移到弹窗外） -->
    <div class="shipping-tips-container">
      <div class="shipping-tips-title">寄件需知</div>
      <div class="shipping-tips">
        <p>
          1、如只是机器故障，只需寄出机器即可，数据线、保护套、电磁笔等配件无需寄回，避免回寄出现丢失，破损等意外情况，感谢您的理解。
        </p>
        <p>2、寄修前请自行做好数据备份，因维修导致的数据丢失，文石概不负责；</p>
        <p>3、快件打包请注意保护好屏幕，避免运输中有损坏；</p>
        <p>4、设备屏幕如有贴膜，如需换屏，屏膜将无法重贴；</p>
        <p>5、寄送前请在包裹内附上包含姓名和手机的纸条，方便查询；</p>
        <p>
          6、经文石检测确认后，需付费维修的设备，从文石发起付费通知七个工作日后如仍未付费确认维修，文石售后维修中心会将设备原路寄回；
        </p>
        <p>7、运费双方各支付一程，请勿寄到付，到付拒收；</p>
      </div>
    </div>

    <area-selector
      v-model="showAreaPicker"
      :initial-area="params.area"
      :http-request="getArealist"
      :provinces="provinceList"
      @confirm="onAreaConfirm"
      @cancel="showAreaPicker = false"
    />

    <van-popup v-model="showExpressPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="expressColumns"
        @confirm="onExpressConfirm"
        @cancel="showExpressPicker = false"
      />
    </van-popup>

    <van-popup v-model="showAddressPopup" position="bottom" round>
      <div class="address-popup">
        <div class="address-popup-title">文石维修地址</div>
        <div class="address-popup-content">
          <p>联系人：文石售后维修</p>
          <p>电话：13826127601</p>
          <p>地址：广州市南沙区东涌镇市鱼路202号一楼（4号楼）</p>
        </div>
        <van-button type="primary" block @click="copyAddress"
          >复制地址</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import AreaSelector from "@/components/AreaSelector.vue";

export default {
  components: {
    AreaSelector,
  },
  props: {
    device: {
      type: Object,
    },
    params: {
      type: Object,
    },
  },
  data() {
    return {
      selectType: "1",
      partsOpts: [],
      provinceList: [], // 省份数据列表
      showAreaPicker: false,
      showExpressPicker: false,
      showAddressPopup: false,
      showPartsPopup: false,
      showLogisticsPopup: false,
      areaText: "",

      expressColumns: [
        { text: "京东", value: "jd" },
        { text: "德邦", value: "debangkuaidi" },
        { text: "顺丰", value: "shunfeng" },
        { text: "极兔", value: "jtexpress" },
        { text: "圆通", value: "yuantong" },
        { text: "申通", value: "shentong" },
        { text: "中通", value: "zhongtong" },
        { text: "韵达快递", value: "yunda" },
        { text: "邮政标准快递", value: "youzhengbk" },
        { text: "EMS", value: "ems" },
        { text: "其他", value: "other" },
      ],
    };
  },
  computed: {
    getPartsDisplayText() {
      if (!this.device.fittings || this.device.fittings.length === 0) {
        return "请选择寄修部件";
      } else if (this.device.fittings.length <= 2) {
        // 显示具体选中的值（最多2项）
        return this.partsOpts
          .filter((item) => this.device.fittings.includes(item.id))
          .map((item) => item.name)
          .join("、");
      } else {
        // 超过2项时显示数量
        return `已选择${this.device.fittings.length}项`;
      }
    },

    getLogisticsDisplayText() {
      // 如果有快递单号，优先显示快递单号
      if (this.params.receiveDeliveryCode) {
        return `单号：${this.params.receiveDeliveryCode}`;
      }
      // 其次显示收货人姓名
      else if (this.params.sendContact) {
        return `收件人：${this.params.sendContact}`;
      }
      // 都没有则显示提示文字
      else {
        return "请填写物流信息";
      }
    },
  },
  methods: {
    confirmParts() {
      if (!this.device.fittings.length) {
        this.$toast("请选择寄修部件");
        return;
      }
      this.setFittingsData();
      this.showPartsPopup = false;
    },

    confirmLogistics() {
      // 检查必填字段
      if (!this.params.sendContact) {
        this.$toast("请输入姓名");
        return;
      }

      if (!this.params.sendPhone || !this.checkphone(this.params.sendPhone)) {
        this.$toast("请输入正确的手机号码");
        return;
      }

      if (!this.params.area || this.params.area.length === 0) {
        this.$toast("请选择所在地区");
        return;
      }

      if (!this.params.tmpAddress) {
        this.$toast("请输入详细地址");
        return;
      }

      // 处理填写信息，确保寄件人信息与回寄信息保持一致
      if (!this.params.phone) {
        this.params.phone = this.params.sendPhone;
      }

      if (!this.params.customer) {
        this.params.customer = this.params.sendContact;
      }

      // 设置国家和区号
      this.params.areaCode = {
        areaCodes: null,
        dialCode: "86",
        iso2: "cn",
        name: "China",
        priority: 0,
      };
      this.params.country = "China";

      this.showLogisticsPopup = false;
    },

    goBack() {
      this.setFittingsData();
      this.$emit("goBack");
    },

    setFittingsData() {
      if (!this.device.fittings.length) return;
      this.device.fittingsData = this.partsOpts.filter((item) =>
        this.device.fittings.includes(item.id)
      );
    },

    async getFittinglist() {
      let res = await this.$http.getFittinglist();
      this.partsOpts = res.data || [];

      if (this.device.fittings.length === 0) {
        const parts = this.partsOpts.find((item) => item.name === "裸机");
        if (parts) {
          this.device.fittings.push(parts.id);
        }
      }
    },

    // 获取地区数据
    async getArealist(params) {
      try {
        const res = await this.$http.getArealist(params);
        return res;
      } catch (error) {
        console.error("获取地区数据失败", error);
        return { data: [] };
      }
    },

    // 加载省份数据
    async loadProvinces() {
      try {
        const res = await this.getArealist();
        this.provinceList = res.data || [];
      } catch (error) {
        console.error("获取省份数据失败", error);
      }
    },

    checkphone(val) {
      if (!val) return false;
      val = val.replace(/\s+/g, "");
      return /^1(3|4|5|6|7|8|9)\d{9}$/.test(val);
    },

    syncUserInfo() {
      this.params.customer = this.params.sendContact;
      this.params.phone = this.params.sendPhone;
      this.$toast("已同步");
    },

    onAreaConfirm(values) {
      // 从组件获取选择的区域数据
      if (values && values.length) {
        const areaNames = values
          .filter((r) => r)
          .map((item) => item.name)
          .filter(Boolean);
        this.areaText = areaNames.join("/");
        this.params.area = areaNames;
      }
      this.showAreaPicker = false;
    },

    onExpressConfirm(value) {
      this.params.receiveDeliveryInc = value;
      this.showExpressPicker = false;
    },

    copyAddress() {
      let str = `联系人：文石售后维修\n电话：13826127601\n地址：广州市南沙区东涌镇市鱼路202号一楼（4号楼）`;

      // 创建临时文本区域
      const textarea = document.createElement("textarea");
      textarea.value = str;
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      textarea.style.top = "0";
      document.body.appendChild(textarea);

      // 选择文本
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      // 尝试复制
      let successful = false;
      try {
        successful = document.execCommand("copy");
      } catch (err) {
        console.error("复制失败", err);
      }

      // 移除临时元素
      document.body.removeChild(textarea);

      // 处理结果
      if (successful) {
        this.$toast.success("复制成功");
      } else {
        this.$toast.fail("复制失败，请手动复制");
      }

      this.showAddressPopup = false;
    },

    submitForm() {
      // 基本验证
      if (!this.device.fittings.length) {
        this.$toast("请选择寄修部件");
        this.showPartsPopup = true;
        return;
      }

      if (
        !this.params.sendContact ||
        !this.params.sendPhone ||
        !this.params.area ||
        this.params.area.length === 0 ||
        !this.params.tmpAddress
      ) {
        this.$toast("请填写物流信息");
        this.showLogisticsPopup = true;
        return;
      }

      this.$emit("nextPage");
    },

    toggleCheckbox(id) {
      const index = this.device.fittings.indexOf(id);
      if (index === -1) {
        // 如果不存在，则添加
        this.device.fittings.push(id);
      } else {
        // 如果已存在，则移除
        this.device.fittings.splice(index, 1);
      }
    },

    initLogistics() {
      this.showLogisticsPopup = true;
      // 如果已经有地区数据，显示地区文本
      if (this.params.area && this.params.area.length) {
        if (Array.isArray(this.params.area)) {
          this.areaText = this.params.area.join("/");
        } else {
          // 如果是字符串，说明是从接口获取的数据，需要处理
          const areas = this.params.area.split("/");
          this.params.area = areas;
          this.areaText = areas.join("/");
        }
      }
    },
  },
  created() {
    // 在组件创建时就加载省份数据
    this.loadProvinces();
  },
  mounted() {
    this.getFittinglist();
  },
};
</script>

<style lang="scss" scoped>
.mobile-step3 {
  background-color: #fff;

  .popup-container {
    display: flex;
    flex-direction: column;
    height: 100%;

    .popup-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #eee;

      .popup-title {
        font-size: 16px;
        font-weight: bold;
      }
    }

    .popup-content {
      flex: 1;
      padding: 0;
      overflow-y: auto;
      background-color: #f5f5f5;

      :deep(.van-cell-group__title) {
        background: #fff;
      }

      :deep(.van-cell) {
        align-items: center;
      }

      .mt10 {
        margin-top: 10px;
      }

      .popup-title-btn {
        border: none;
        color: #1989fa;
        font-size: 12px;
        font-weight: normal;
        text-decoration: underline;
        padding: 0 16px;
      }
    }

    .popup-footer {
      padding: 16px;
      border-top: 1px solid #eee;
    }
  }

  .address-popup {
    padding: 20px;

    .address-popup-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
      text-align: center;
    }

    .address-popup-content {
      margin-bottom: 20px;

      p {
        margin: 8px 0;
        font-size: 14px;
      }
    }
  }

  .shipping-tips-container {
    margin-top: 10px;
    background-color: #fff;

    .shipping-tips-title {
      font-size: 14px;
      padding: 0 16px;
    }

    .shipping-tips {
      padding: 5px 16px;

      p {
        font-size: 12px;
        color: #666;
        margin: 8px 0;
        line-height: 1.5;
      }
    }
  }
}

::v-deep .van-field__control {
  text-align: right;
}

::v-deep .van-field--textarea .van-field__control {
  text-align: left;
}

.field-tip {
  padding: 0 16px;
  font-size: 12px;
  color: #f44;
  background-color: #fff;
  padding-bottom: 10px;
}

.orange {
  background-color: #ce653e;
  border-color: #ce653e;
}
</style>
